var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":_vm.backicon,"width":"20"}})])}
var staticRenderFns = []

export { render, staticRenderFns }